/*
 * @Author: your name
 * @Date: 2021-11-10 23:27:16
 * @LastEditTime: 2022-05-06 04:00:24
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'

/**
 * 路由管理
 */
import router from './router'

/**
 * 内存管理
 */
import store from './store'

/**
 * 全局css
 */
import './styles/index.less'

/**
 * 校验守卫
 */
import './permission.js'

/**
 * 全局过滤器
 */
import './filters'

/**
 * 全局插件和工具
 */
import './plugins'

/**
 * 全局组件注册
 */
import './components/global'

/**
 * 图标
 */
import './assets/icons/iconfont.css'

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
 
Vue.use(VueVideoPlayer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

